<script>
import BookingSectionRadio from './BookingSectionRadio';
import BookingSectionCheckbox from './BookingSectionCheckbox';

export default {
  components: {
    BookingSectionCheckbox,
    BookingSectionRadio
  },
  props: {
    formField: {
      type: Array,
      required: true,
    },
    alias: {
      type: [String, Number],
      required: true,
    },
    inputData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      formData: {},
    }
  },
  computed: {
    isFormValid() {
      return Object.keys(this.fields).some((key) => this.fields[key].invalid)
    },
  },
  watch: {
    inputData: {
      handler(v, ov) {
        this.formData = v
      },
      deep: true
    },
    formData: {
      handler(v, ov) {
        this.$emit('update:inputData', v);
      },
      deep: true
    }
  },
  mounted() {
    this.setFromData();
  },
  methods: {
    setFromData() {
      /* this.$nextTick(() => {
        Object.keys(this.inputData).forEach(key => {
          this.$set(this.formData, key, this.inputData[key])
        })
      }) */
      this.$nextTick(() => {
        this.formField.forEach(item => {
          this.$set(this.formData, item.id, this.inputData[item.id])
        })
      })
    }
  },
}

</script>
<template>
  <div>
    <template v-for="(orderExtrafield, index) in formField">
      <template v-if="orderExtrafield.value">
        <b-field :key="index"
                 class="is-style-extrafield-text"
                 :label="orderExtrafield.title"
                 :class="{ [$style['isRequired']]: orderExtrafield.required }"
        >
          <b-input
            v-model="formData[orderExtrafield.id]"
            disabled
            :name="`${orderExtrafield.id}_${alias}`"
            expanded
          ></b-input>
        </b-field>
      </template>
      <template v-else>
        <BookingSectionCheckbox
          v-if="orderExtrafield.type === 'checkbox'"
          :key="index"
          :input-data.sync="formData[orderExtrafield.id]"
          :field="orderExtrafield"
          :name="`${orderExtrafield.id}_${alias}`"
        />
        <BookingSectionRadio
          v-if="orderExtrafield.type === 'radio'"
          :key="index"
          :input-data.sync="formData[orderExtrafield.id]"
          :field="orderExtrafield"
          :name="`${orderExtrafield.id}_${alias}`"
        />
        <b-field
          v-if="orderExtrafield.type === 'text'"
          :key="index"
          :message="errors.first(orderExtrafield.id)"
          :type="{ 'is-danger': errors.has(orderExtrafield.id) }"
          class="is-style-extrafield-text"
          :label="orderExtrafield.title"
          :class="{ [$style['isRequired']]: orderExtrafield.required }"
        >
          <b-input
            v-model="formData[orderExtrafield.id]"
            v-validate="{ required: Boolean(orderExtrafield.required) }"
            :data-vv-as="orderExtrafield.title"
            :name="`${orderExtrafield.id}_${alias}`"
            expanded
          ></b-input>
        </b-field>
      </template>
    </template>
  </div>
</template>
<style lang="scss" module>
  .isRequired {
    :global(.label::after) {
      margin-left: 4px;
      color: $color-danger;
      content: '*';
    }
  }
</style>
